/* eslint-disable custom/no-hex-colors */
const initialColors = [
  '#e44234',
  '#ff8d00',
  '#ffcd45',
  '#5cc96e',
  '#25d2d1',
  '#597ce2',
  '#c544ce',
  '#7d2e25',
  '#a84f1d',
  '#e99e38',
  '#347842',
  '#167e7d',
  '#354a87',
  '#76287b',
  '#ffffff',
  '#cdcdcd',
  '#9c9c9c',
  '#696969',
  '#272727',
  '#000000'
];

const initialTextColors = [
  '#000000',
  '#272727',
  '#696969',
  '#9c9c9c',
  '#cdcdcd',
  '#ffffff',
  '#7d2e25',
  '#a84f1d',
  '#e99e38',
  '#347842',
  '#167e7d',
  '#354a87',
  '#76287b',
  '#e44234',
  '#ff8d00',
  '#ffcd45',
  '#5cc96e',
  '#25d2d1',
  '#597ce2',
  '#c544ce'
];
/* eslint-enable custom/no-hex-colors */

export {
  initialColors,
  initialTextColors,
};